/*
* Copyright (C) Regione Lombardia
*/
import { Component } from '@angular/core';

@Component({
    selector: 'app-pages-gestione-utente-attesa-profilo',
    templateUrl: './attesa-profilo.component.html',
})
export class PagesGestioneUtenteAttesaProfiloComponent { }
